import type { DataAPIEventRow } from '../../codingconstitution/framework';

type Props = { items?: DataAPIEventRow[] };

export function DatabaseAPIEventPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-400">{item.category}: {item.item}</p>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{item.standard}</p>
          <span className="mt-1 inline-block rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-950 dark:text-amber-300">
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
